/* eslint-disable no-use-before-define */
import { useEffect } from 'react';
import { FormControl } from '@mui/material';
import PropTypes from 'prop-types';

import ButtonComponent from '../../../../../components/ButtonComponent';
import Input from '../../../../../components/Form/Input';
import { REGISTER_STEPS } from '../../../../../constants/registerSteps';
import { isValidCNPJ, isValidCellphone } from '../../../../../utils';
import styles, { FormContainer, Footer } from '../../styles';
import { errorMessages } from './helpers';
import useFormStep from './useFormStep';
import StepsHeadline from './StepsHeadline';

const formStep = REGISTER_STEPS.COMPANY_INFO;
const notMandatoryFields = ['phone'];

export default function CompanyInfo({ handleBack, handleNext }) {
  const registerCompany = () => handleNext();

  const validateField = (name, value) => {
    if (notMandatoryFields.includes(name) && !value?.trim()) return '';
    if (!value?.trim()) return errorMessages.MANDATORY_FIELD;

    switch (name) {
      case 'cnpj':
        if (!isValidCNPJ(value)) return 'CNPJ inválido';
        break;
      case 'name':
        if (value.length > 200) return 'Nome deve ter no máximo 200 caracteres';
        break;
      case 'phone':
        if (!isValidCellphone(value)) return 'Telefone inválido';
        break;
      default:
        return '';
    }
    return '';
  };

  const {
    form,
    formErrors,
    isLoading,
    inputRef,
    handleChange,
    handleSubmit,
    updateRedux,
    isStepValid,
  } = useFormStep(formStep, validateField, registerCompany);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <FormContainer onSubmit={handleSubmit}>
      <StepsHeadline />

      <FormControl sx={styles.textField} variant="standard">
        <Input
          placeholder="CNPJ"
          value={form.cnpj}
          ref={inputRef}
          onAccept={(value) => handleChange({ target: { name: 'cnpj', value } })}
          type="tel"
          name="cnpj"
          mask="00.000.000/0000-00"
          error={!!formErrors.cnpj}
          helperText={formErrors.cnpj}
          disabled={isLoading}
        />
      </FormControl>

      <FormControl sx={styles.textField} variant="standard">
        <Input
          placeholder="Nome da empresa"
          value={form.name}
          onChange={handleChange}
          type="text"
          name="name"
          inputProps={{ maxLength: 200 }}
          error={!!formErrors.name}
          helperText={formErrors.name}
          disabled={isLoading}
        />
      </FormControl>

      <FormControl sx={styles.textField} variant="standard">
        <Input
          placeholder="Telefone (opcional)"
          value={form.phone}
          onAccept={(value) => handleChange({ target: { name: 'phone', value } })}
          type="tel"
          name="phone"
          mask="(00) 00000-0000"
          error={!!formErrors.phone}
          helperText={formErrors.phone}
          disabled={isLoading}
        />
      </FormControl>

      <Footer style={styles.registerStepsFooter}>
        <ButtonComponent
          size="small"
          variant="outlined"
          disabled={isLoading}
          onClick={() => {
            updateRedux();
            handleBack();
          }}
        >
          Voltar
        </ButtonComponent>

        <ButtonComponent
          type={isLoading ? 'button' : 'submit'}
          size="small"
          disabled={!isStepValid() || isLoading}
          loading={isLoading}
        >
          Próximo
        </ButtonComponent>
      </Footer>
    </FormContainer>
  );
}

CompanyInfo.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};
